import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import useStyles from "../../../../styles";

import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { sanitizeInput } from "../../../../Utils/validationUtils";
import OtpPopup from "../OtpPopup/OtpPopup";

function AddCoursesForm() {
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);

  // OTP popup state
  const [otpOpen, setOtpOpen] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/active/list`,
          { headers: { Authorization: `Bearer ${decryptedToken}` } }
        );
        setSubjects(response.data.subjects || []);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };
    fetchSubjects();
  }, [decryptedToken]);

  const handleClose = () => {
    navigate("/admin/authuser");
  };

  // Step 1: Validate → call send-OTP API → open popup
  const handleFormSubmit = async () => {
    if (!name.trim()) {
      toast.warn("Please enter a name.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim() || !emailRegex.test(email)) {
      toast.warn("Please enter a valid email address.");
      return;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phone.trim() || !phoneRegex.test(phone)) {
      toast.warn("Please enter a valid 10-digit phone number.");
      return;
    }

    if (selectedSubjects.length === 0) {
      toast.warn("Please select at least one subject.");
      return;
    }

    // Send OTP to phone number
    setSendingOtp(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth_user/otp/send`,
        {},
        { headers: { Authorization: `Bearer ${decryptedToken}` } }
      );
      toast.success("OTP sent to your phone number");
      setOtpOpen(true); // open popup AFTER OTP is sent
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Failed to send OTP. Please try again.";
      toast.error(msg);
    } finally {
      setSendingOtp(false);
    }
  };

  return (
    <>
      <ToastContainer />

      {/* OTP Gate — autoSend=false because we already sent OTP in handleFormSubmit.
          verifyOtpApi = /v1/b2b/auth_user/add so the final body is:
          { otp: "...", auth_user: { name, email, phone } }                        */}
      <OtpPopup
        open={otpOpen}
        autoSend={false}
        onClose={() => setOtpOpen(false)}
        onVerified={() => {
          setOtpOpen(false);
          sessionStorage.setItem("auth_user", "yes");
          toast.success("Auth User created successfully");
          setTimeout(() => navigate("/admin/authuser"), 2000);
        }}
        sendOtpApi={`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth_user/otp/send`}
        verifyOtpApi={`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth_user/add`}
        payload={{
          auth_user: {
            name: name,
            email: email,
            phone: phone,
            subject_ids: selectedSubjects,
          },
        }}
        resendPayload={{}}
        otpFieldKey="otp"
      />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
               Auth User Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                 Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setName(sanitizeInput(e.target.value, "textInput"))}
                  value={name}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >

                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                 Email <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="email"
                  variant="outlined"
                  required
                  placeholder="Enter Email Address"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >

                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                 Phone No. <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) =>
                    setPhone(e.target.value.replace(/[^0-9]/g, "").slice(0, 10))
                  }
                  value={phone}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Phone No."
                  inputProps={{ maxLength: 10 }}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Subject <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="subject-autocomplete"
                  disableClearable
                  options={subjects}
                  getOptionLabel={(option) => option.subject_name || ""}
                  value={subjects.filter((s) =>
                    selectedSubjects.includes(s.id)
                  )}
                  onChange={(event, newValue) => {
                    setSelectedSubjects(newValue.map((v) => v.id));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Subjects"
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
            </div>
          </div>
          <div className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}>
            <Button onClick={handleClose} className={`${classes.custombtnoutline}`}>Cancel</Button>
            <Button
              onClick={handleFormSubmit}
              disabled={sendingOtp}
              className={`${classes.custombtnblue}`}
            >
              {sendingOtp ? "Sending OTP..." : "Submit"}
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddCoursesForm;
